import { Component } from '@angular/core';
import { AvailableOrg, OrgAccessService } from '../services/org-access.service';

/**
 * Shown when the organization the user is working in becomes inactive for them: they switch to another active
 * organization or log out. It cannot be dismissed, since every request for the inactive organization is rejected.
 */
@Component({
  selector: 'app-org-inactive-modal',
  templateUrl: './org-inactive-modal.component.html',
  styleUrls: ['./org-inactive-modal.component.scss']
})
export class OrgInactiveModalComponent {
  readonly state$ = this.orgAccessService.state$;

  constructor(private orgAccessService: OrgAccessService) {}

  switchTo(org: AvailableOrg): void {
    this.orgAccessService.switchTo(org);
  }

  logout(): void {
    this.orgAccessService.logout();
  }

  formatRole(role: string): string {
    return (role || '').replace(/[_-]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
}
